import React, { useContext } from 'react';

import PaymentLinkContext from '@/pages/Checkout/context/PaymentLinkContext';

import CardInfo from '@/components/CardInfo';
import Actions from '@/components/Actions';
import InternalPage from '@/components/InternalPage';

const Details: React.FC = () => {
  const { setCurrentStep, maxSteps } = useContext(PaymentLinkContext);

  return (
    <InternalPage
      columns={8}
      title="Confira o resumo"
      steps={{ currentStep: 1, steps: maxSteps }}
    >
      <CardInfo />
      <Actions
        submitType="button"
        nextStep={() => setCurrentStep('personal')}
      />
    </InternalPage>
  );
};

export default Details;
